<template>
  <div class="new-password-request-form" layout layout-align="center-center">
    <form @submit.prevent="submit($v)">
      <el-card>
        <div class="el-card-header">
          <div class="logo"><img src="@/client/assets/images/atelu_logo.svg" /></div>
        </div>
        <div class="mt-x2">
          <div class="message message-info">
            パスワードを再設定するため、登録済みのメールアドレスを入力してください。
          </div>
          <div class="input-container">
            <el-input
              :class="{ error: $v.email.required && $v.email.$error, success: $v.email.required && !$v.email.$invalid }"
              placeholder="メールアドレス"
              :maxlength="100"
              type="text"
              v-model="email"
              @blur="$v.email.$touch"
              tabindex="1"
            >
              <template slot="prepend"><i class="mdi mdi-email"></i></template>
            </el-input>
            <div class="invalid" v-if="!$v.email.required && $v.email.$error">メールアドレスを入力してください。</div>
            <div class="invalid" v-if="!$v.email.email && $v.email.$error">
              メールアドレスの形式が正しくありません。
            </div>
          </div>
        </div>
        <div class="el-card-action">
          <el-button class="mb-x2" type="primary" native-type="submit" :disabled="$v.$invalid === true"
            ><i class="mdi mdi-send"></i>再設定メールを送信</el-button
          >
          <el-button @click="$router.push('/login')"><i class="mdi mdi-arrow-left"></i>ログイン画面に戻る</el-button>
        </div>
      </el-card>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.new-password-request-form {
  height: 100%;
}

form {
  width: 100%;
  max-width: $spacing-unit * 62;
}

.el-card {
  width: 100%;
  padding: $spacing-unit * 2;
}

.el-card-header {
  padding: $spacing-unit * 3;

  .logo {
    text-align: center;
  }
}

.el-card-action {
  display: block;
  margin: $spacing-unit * 6 0 $spacing-unit * 2 0;

  button {
    width: 100%;
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}

.input-container {
  width: 100%;
  margin: $spacing-unit * 3 0 0;

  .invalid {
    display: block;
    margin-top: $spacing-unit;
    font-size: $font-small-size;
    color: $danger-color;
  }
}

.small {
  margin-top: $spacing-unit;
}

.message {
  padding: $spacing-unit;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue'
import { email, required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'

export default defineComponent({
  data() {
    return {
      email: ''
    }
  },
  methods: {
    /**
     * ログインサブミット
     * @return {void}
     */
    submit: async function ($v: any) {
      // validations
      $v.$touch()
      if ($v.$invalid === true) {
        return
      }

      const params = {
        email: this.email
      }
      const result = await api.post('/users/new_password_requests', params)
      // エラーがある場合は表示
      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: 'メールアドレスが登録されていません。',
          message: '',
          customClass: 'danger',
          duration: 10000
        })
        this.$router.push('/login')
        return
      }
      if (result.data !== true) {
        this.$notify({
          title: 'エラーが発生しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 10000
        })
        return
      }

      // 成功する場合
      this.$notify({
        title: '確認メールを送信しました。',
        message: 'メールが届かない場合は、再度確認メールを送信してください。',
        customClass: 'success',
        duration: 10000
      })
      this.$router.push('/login')
    }
  },
  validations: {
    email: {
      required,
      email
    }
  }
})
</script>
